import React from 'react';
import './NotFound.css'

const NotFound = () => {
    return (
        <div className='error min-h ps-0 ps-lg-5'>
            <div className='error-div ps-0 ps-lg-5'>
               <img src="https://i.postimg.cc/PxM0wH8X/7aqcppklh6bexoa70320.webp" alt="" />
            </div>
        </div>
    );
};

export default NotFound;